import { render } from "./OptionalAgree.vue?vue&type=template&id=59812a58&ts=true"
import script from "./OptionalAgree.vue?vue&type=script&lang=ts"
export * from "./OptionalAgree.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__